import styles from './PrivacyPolicy.module.scss';
import { NexusModal } from '@nexus/react';
import { useAppDispatch, useAppSelector } from '../../../store';
import { getUserProfile, updateUserProfile } from '../../../store/customSlice/userProfileSlice';
import { useEffect, useState } from 'react';
import { ApiState } from '../../../store/constants/enums';
import ButtonComponent from '../../components/nds/button/button';
import LoaderComponent from '../../components/nds/loader/loader';
import { NexusTabBar } from '@nexus/react';
import PDFViewer from './pdfViewer';
//@ts-ignore
import privacyPolicy from './Privacy.pdf';
//@ts-ignore
import termsandconditions from './TermsAndCondition.pdf';

const tabs = [
    {
        title: 'Privacy Policy',
        isActive: true,
        src: privacyPolicy,
        acknowledged: false,
        selectedOption: null,
    },
    {
        title: 'Terms and Conditions',
        isActive: false,
        src: termsandconditions,
        acknowledged: false,
        selectedOption: null,
    },
];

interface PrivacyPolicyProps {
    handleLogout: () => void;
    userPreferences: any;
}

interface tabOption {
    tabOption: {
        title: string;
        isActive?: boolean;
        src: string;
        acknowledged?: boolean;
        selectedOption?: string | null;
    }[];
}

const PrivacyPolicy = (props: PrivacyPolicyProps) => {
    const [selectedOption, setSelectedOption] = useState<string | null>(null);
    const [isBtnDisabled, setIsBtnDisabled] = useState(true);
    const [isLoaderShow, setIsLoaderShow] = useState<boolean>(false);
    const [tabOptions, setTabOptions] = useState<tabOption['tabOption']>(tabs);
    const dispatch = useAppDispatch();
    const { userPreferences, apiState } = useAppSelector().userProfileSlice;

    const ChangeActive = (index: number) => {
        const selectedTab = [...tabOptions];

        selectedTab.forEach((option) => {
            option.isActive = false;
        });
        selectedTab[index].isActive = true;
        setTabOptions(selectedTab);
    };

    function handleRadioChange(selOpt: string, index: number) {
        const selectedTab = [...tabOptions];

        if (selOpt === 'Yes') {
            selectedTab[index].selectedOption = 'Yes';
        } else {
            selectedTab[index].selectedOption = 'No';
        }

        const filteredTabs = selectedTab.filter((option) => option.selectedOption === 'Yes');
        const filter = selectedTab.filter((option) => option.selectedOption === null);
        if (filteredTabs.length === tabOptions.length) {
            setSelectedOption('Yes');
        } else {
            setSelectedOption('No');
        }
        if (filter.length === 0) {
            setIsBtnDisabled(false);
        } else {
            setIsBtnDisabled(true);
        }
        setTabOptions(selectedTab);
    }

    useEffect(() => {
        const isAcceptedTnc = props.userPreferences?.isAcceptedTnc;
        const isAcceptedPrivacyNotice = props.userPreferences?.isAcceptedPrivacyNotice;
        const tabValue = [...tabOptions];
        tabValue[0].selectedOption = isAcceptedPrivacyNotice ? 'Yes' : isAcceptedPrivacyNotice === false ? 'No' : null;
        tabValue[1].selectedOption = isAcceptedTnc ? 'Yes' : isAcceptedTnc === false ? 'No' : null;
        setTabOptions(tabValue);
    }, [props.userPreferences]);

    useEffect(() => {
        if (apiState.updateUserProfile === ApiState.FULFILLED && selectedOption === 'No') {
            props.handleLogout();
        } else {
            dispatch(getUserProfile());
        }
        setIsLoaderShow(false);
    }, [apiState.updateUserProfile]);

    const proceed = () => {
        setIsLoaderShow(true);
        dispatch(
            updateUserProfile({
                languageCode: userPreferences.languageCode,
                languageName: userPreferences.languageName,
                timeZone: userPreferences.timeZone,
                paidById: userPreferences.paidById,
                administeredById: userPreferences.administeredById,
                currencyCode: userPreferences.currencyCode,
                defaultRows: userPreferences.defaultRows,
                clientLobFlag: userPreferences.clientLobFlag,
                isAcceptedPrivacyNotice: tabOptions[0].selectedOption === 'Yes',
                isAcceptedTnc: tabOptions[1].selectedOption === 'Yes',
                dateFormat: userPreferences.dateFormat,
            }),
        );
    };

    return (
        <>
            <NexusModal
                className={styles['modal-element'] + ' ' + styles['privacy-overlay']}
                data-testid='pricacy-policy-modal'
                id='modal'
                show={true}
                fullscreen={false}
                size={'lg'}
            >
                <div className={styles['modal-scroll']}>
                    <div className={styles['modal-container']} data-testid='modal-body'>
                        <div style={{ marginTop: '20px' }}>
                            <NexusTabBar data-testid='privacy-tabbar' className={styles['tab-container']}>
                                {tabOptions.map((option: any, index: number) =>
                                    option.isActive ? (
                                        <span key={index}>
                                            <button
                                                className='nexus-link nexus-active'
                                                data-testid={option.title}
                                                onClick={() => ChangeActive(index)}
                                            >
                                                {option.title}{' '}
                                                <span style={{ color: 'red', paddingLeft: '5px' }}>*</span>
                                            </button>
                                        </span>
                                    ) : (
                                        <span key={index}>
                                            <button
                                                className='nexus-link'
                                                data-testid={option.title}
                                                onClick={() => ChangeActive(index)}
                                            >
                                                {option.title}{' '}
                                                <span style={{ color: 'red', paddingLeft: '5px' }}>*</span>
                                            </button>
                                        </span>
                                    ),
                                )}
                            </NexusTabBar>
                        </div>

                        {tabs.map(
                            (option, index) =>
                                option.isActive && (
                                    <PDFViewer
                                        key={index}
                                        id={index}
                                        selectedOption={
                                            option.selectedOption === null ? undefined : option.selectedOption
                                        }
                                        handleRadioChange={handleRadioChange}
                                    />
                                ),
                        )}

                        <p>Note: Please accept both the Privacy Policy and Terms and Conditions to continue.</p>
                        <hr />
                        <br />
                        <div className={styles['btn-proceed'] + ' nexus-col-lg-2 nexus-col-sm-1 nexus-pb-4'}>
                            <ButtonComponent
                                type={'primary'}
                                label={'Proceed'}
                                onClick={proceed}
                                disabled={isBtnDisabled}
                            ></ButtonComponent>
                        </div>
                    </div>
                </div>
            </NexusModal>
            <LoaderComponent show={isLoaderShow} fullscreen={true} />
        </>
    );
};

export default PrivacyPolicy;
